module.exports = __webpack_public_path__ + "static/media/spinner.b6e501f7.svg";